'use client';

import { useState } from 'react';
import { Box, HStack } from '@terra/ui-styled-system';
import { ArrowDown01Icon, ArrowRight01Icon } from '@terra/ui-icons';
import { Collapsible } from '../../../../components/collapsible';
import { MarkdownPreview } from '../../../markdown-preview';
import { TraceThoughtLabel } from './TraceThoughtLabel';

type TraceReasoningCardProps = {
  text: string;
  defaultOpen?: boolean;
  contentFontSize?: number;
};

export function TraceReasoningCard({
  text,
  defaultOpen = false,
  contentFontSize = 12,
}: TraceReasoningCardProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const trimmedText = text.trim();
  const hasContent = trimmedText.length > 0;

  if (!hasContent) return null;

  return (
    <Collapsible.Root
      open={isOpen}
      onOpenChange={({ open }) => setIsOpen(open)}
    >
      <Collapsible.Trigger asChild>
        <HStack
          width="100%"
          gap={1.5}
          alignItems="center"
          py={1}
          cursor="pointer"
          borderRadius="sm"
          fontSize="xs"
          color="fg.subtle"
        >
          <TraceThoughtLabel text={trimmedText} />
          <Box display="flex" alignItems="center" flexShrink={0}>
            {isOpen ? (
              <ArrowDown01Icon size={12} />
            ) : (
              <ArrowRight01Icon size={12} />
            )}
          </Box>
        </HStack>
      </Collapsible.Trigger>

      <Collapsible.Content>
        <Box pt={1} pb={2} color="fg.subtle">
          <MarkdownPreview
            source={trimmedText}
            fontSize={contentFontSize}
            compact
          />
        </Box>
      </Collapsible.Content>
    </Collapsible.Root>
  );
}
